import React from 'react';
import { Col, Row, Card, CardTitle, CardBody } from 'reactstrap';

const DashboardCard = ({ cardClasses, title, titleClasses, subTitle, subTitleClass, iconClass, iconBackground, children }) => {
    return (
        <Card className={`card-stats ${cardClasses ? cardClasses.join(' ') : ''}`}>
            <CardBody>
                <Row>
                    <Col>
                        <CardTitle tag="h5" className={`text-uppercase mb-1 ${titleClasses ? titleClasses.join(' ') : 'text-muted' }`}>
                            {title}
                        </CardTitle>
                        {
                            subTitle &&
                            <h2 className={`${subTitleClass ? subTitleClass : "h4"} font-weight-bold`}>
                                {subTitle}
                            </h2>
                        }
                    </Col>
                    {
                        iconClass &&
                        <Col className="col-auto">
                            <div className={`icon icon-shape text-white rounded-circle shadow ${iconBackground}`}>
                                <i className={iconClass}></i>
                            </div>
                        </Col>
                    }
                </Row>
                {children}
            </CardBody>
        </Card>
    );
}

export default DashboardCard;